import React from 'react'
import AppContext from '../../AppContext'
import { featureEnabled, env } from 'components/Helpers'
import { NotEnabledPage } from 'scenes/NotEnabled'

const egymWellpassApi = () =>
  process.env.REACT_APP_EGYM_WELLPASS_API ||
  `https://egym-wellpass.${env()}.credlock.net/api/v1`

export default ({ match }) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id } } = React.useContext(AppContext)

  if (!id) {
    return (
      <div className='index egym-wellpass'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  if (!featureEnabled('wellpass', id)) {
    return (<NotEnabledPage />)
  }

  return (
    <div className='index egym-wellpass'>
      {/* eslint-disable-next-line */}
      <h1></h1>
      <cl-egym-wellpass-admin
        apihost={egymWellpassApi()}
        mountPath={`/operators/${id}/egym-wellpass`}
        token={token}
      />
    </div>
  )
}
